"use strict";
function FaqCollapse() {
    var faqSelector = '.js-faq';
    var faqContent = '.js-faq-content';
    var faqHeader = document.querySelectorAll('.js-faq-header');
    // States
    var faqOpened = 'm-faq-item--opened';
    var parentSelector;
    faqHeader.forEach(function (faq) {
        faq.addEventListener('click', function () {
            var _a;
            parentSelector = faq.closest(faqSelector);
            if (parentSelector) {
                parentSelector.classList.toggle(faqOpened);
                (_a = parentSelector.querySelector(faqContent)) === null || _a === void 0 ? void 0 : _a.classList.toggle('m-faq-item__expanded');
            }
        });
    });
}
document.addEventListener('DOMContentLoaded', function () {
    FaqCollapse();
});
